import React, { forwardRef } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import { useBarChartStepperButtonStyles } from '../../utils/styles.esm.js';

const BarChartStepperButton = forwardRef(
  ({
    name,
    children,
    ...buttonBaseProps
  }, ref) => {
    const classes = useBarChartStepperButtonStyles();
    return /* @__PURE__ */ React.createElement(
      ButtonBase,
      {
        ref,
        classes,
        disableRipple: true,
        "data-testid": `bar-chart-stepper-button-${name}`,
        ...buttonBaseProps
      },
      children
    );
  }
);

export { BarChartStepperButton };
//# sourceMappingURL=BarChartStepperButton.esm.js.map
